import {Box, HStack, Text, Flex, Icon} from '@chakra-ui/react'
import {useState} from 'react'
import {CommonColors} from '@utils/CommonStyles'
import './index.css'
import {ReactComponent as PlusCircle} from '@assets/svgs/plus_circle.svg'
import {ReactComponent as MinusCircle} from '@assets/svgs/minus_circle.svg'

const SuggestionItem = ({suggestion}: {suggestion: any}) => {
  const [isShowDetail, setIsShowDetail] = useState<boolean>(false)
  return (
    <HStack
      width="100%"
      flexDirection={'column'}
      alignItems={'flex-start'}
      borderBottom={'1px solid #E4E7EC'}
      pb={4}>
      <HStack spacing={2}>
        <Flex gap={2} flex={1}>
          <Text fontSize={'16px'}>{suggestion?.original}</Text>
          <Text fontWeight="600" color={CommonColors.primary}>
            →
          </Text>
          <Text fontSize={'16px'}>{suggestion?.suggestion}</Text>
        </Flex>
        <Icon
          fontSize={'16px'}
          as={isShowDetail ? MinusCircle : PlusCircle}
          cursor={'pointer'}
          onClick={() => setIsShowDetail(!isShowDetail)}
        />
      </HStack>
      {isShowDetail && (
        <Box mt={2}>
          {suggestion?.detail
            ?.split('-')
            .filter((point: string) => point.trim())
            .map((point: string, idx: number) => (
              <Text key={idx} color="#667085" fontSize={'16px'}>
                - {point.trim()}
              </Text>
            ))}
        </Box>
      )}
    </HStack>
  )
}

export default SuggestionItem
